import { Component, OnInit, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-rfid',
  templateUrl: './rfid.component.html',
  styleUrls: ['./rfid.component.scss']
})
export class RfidComponent implements OnInit {
  digopen: any;

  bsuCurrency: string = '';
  studentName: string = '';
  studentSchool: string  = '';
  studentSchoolId: string  = '';
  studentTransportId: string = '';
  studentGrade: string = '';
  studentSection: string = '';
  studentProfilePhoto: string = '';

  file: File;
  base64Conversion: any;
  fileType: any;
  base64String: any;
  fileErr:boolean=false;

  checked: boolean = false;



  constructor(private dialog: MatDialog, private router: Router) { }

  ngOnInit(): void {
    this.bsuCurrency = localStorage.getItem('bsu_currency');


    this.studentName = JSON.parse(localStorage.parentChildrens)[0].studentName;
    this.studentSchool = JSON.parse(localStorage.parentChildrens)[0].school;
    this.studentProfilePhoto = JSON.parse(localStorage.parentChildrens)[0].photoPath;
    this.studentTransportId = JSON.parse(localStorage.parentChildrens)[0].studentId;
    this.studentGrade = JSON.parse(localStorage.parentChildrens)[0].grade;
    this.studentSection = JSON.parse(localStorage.parentChildrens)[0].section;

    let studentTransportInfo = JSON.parse(localStorage.getItem('transportChildInfo'));
    let selectedStudentId = localStorage.getItem('selectedstudentid');
    let selectedStudentData = studentTransportInfo?.filter((x: any) => x.studentNo == selectedStudentId);

    this.studentSchoolId = selectedStudentData[0]?.stU_SCHOOL_ID;
  }

  selectedImgFile(event:any)
  {
     this.file= event.target.files[0];
     let splits=this.file.name.split(".");
     this.fileType=splits[1];
    if (this.file) {
      if( this.fileType=="jpeg" || this.fileType=="jpg")
     {
       this.fileErr=false;
      const reader = new FileReader();
      reader.readAsDataURL(this.file);
      reader.onload = (e: any) => {
        this.base64String=e.target.result;
        this.base64String= this.fileType == "png" ? this.base64String.replace("data:image/png;base64,",""): this.fileType=="jpg"? this.base64String.replace("data:image/jpeg;base64,","") : this.base64String.replace("data:image/jpeg;base64,","");
        this.studentProfilePhoto = e.target.result;

      };
    }else this.fileErr=true;
    }
  }

  submitRequest(template: TemplateRef<any>){
    this.successDialog(template);
  }

  successDialog(templateRef: TemplateRef<any>) {
    this.digopen = this.dialog.open(templateRef, {
      width: '500px',
      panelClass: 'custom-modalbox'
    });
  }

  ok()
  {
    this.digopen.close();
    this.router.navigate(['/home']);
  }


  selectedValue = "Option 2 - Description for option 2";
}
